import { Image, Paper, Text, ThemeIcon } from "@mantine/core";
import { Link } from "react-router-dom";
import BackgroundPattern from "../../assets/bg-pattern.png";
import classes from "./card.module.css";

export function GridCard({ data }: any) {
  if (data.disabled) {
    return (
      <Paper withBorder className={classes.disable}>
        <ThemeIcon size="xl" radius={4} variant="gradient">
          <data.icon size={28} stroke={1.5} />
        </ThemeIcon>
        <Text size="lg" c={"white"} fw={500} mt="md">
          {data.title}
        </Text>
        <Text size="sm" mt="sm" c="white">
          {data.description}
        </Text>
      </Paper>
    );
  }

  return (
    <Link to={`${data.link}/${data.homeLink}`} className={classes.container}>
      <Image src={BackgroundPattern} alt="" className={classes.background} />
      <Paper withBorder className={classes.card}>
        <ThemeIcon size="xl" radius={4} variant="gradient">
          <data.icon size={28} stroke={1.5} />
        </ThemeIcon>
        <Text size="lg" c={"white"} fw={500} mt="md">
          {data.title}
        </Text>
        <Text size="sm" mt="sm" c="white">
          {data.description}
        </Text>
      </Paper>
    </Link>
  );
}
